export default __webpack_public_path__ + "static/media/afterHero3.6b169434.png";